import { FavOriginsActionTypes } from './constants';

const INIT_STATE = {
    favOrigin: {},
    listaFavOrigins: [],
    loading: false,
    error: false,
    formSubmited: false
};

type FavOriginsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { favOrigin?: {} | null, listaFavOrigins?: [] | null, loading?: boolean, +value ?: boolean };

const FavOrigins = (state: State = INIT_STATE, action: FavOriginsAction): any => {
    // console.log(action);
    switch (action.type) {
        case FavOriginsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case FavOriginsActionTypes.GET_FAV_ORIGIN: {
                    return {
                        ...state,
                        favOrigin: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case FavOriginsActionTypes.LIST_FAV_ORIGINS: {
                    return {
                        ...state,
                        listaFavOrigins: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case FavOriginsActionTypes.ADD_FAV_ORIGIN: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case FavOriginsActionTypes.UPDATE_FAV_ORIGIN: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case FavOriginsActionTypes.DELETE_FAV_ORIGIN: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case FavOriginsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case FavOriginsActionTypes.GET_FAV_ORIGIN: {
                    return {
                        ...state,
                        error: action.payload.error,
                        favOrigin: {},
                        loading: false,
                    };
                }
                case FavOriginsActionTypes.LIST_FAV_ORIGINS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaFavOrigins: [],
                        loading: false,
                    };
                }
                case FavOriginsActionTypes.ADD_FAV_ORIGIN: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case FavOriginsActionTypes.UPDATE_FAV_ORIGIN: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case FavOriginsActionTypes.DELETE_FAV_ORIGIN: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case FavOriginsActionTypes.GET_CATEGORIA:
            return { ...state, error: false, loading: true };
        case FavOriginsActionTypes.LIST_CATEGORIAS:
            return { ...state, error: false, loading: true };
        case FavOriginsActionTypes.ADD_CATEGORIA:
            return { ...state, error: false, loading: true };
        case FavOriginsActionTypes.UPDATE_CATEGORIA:
            return { ...state, error: false, loading: true };
        case FavOriginsActionTypes.DELETE_CATEGORIA:
            return { ...state, error: false, loading: true };
        case FavOriginsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                favOrigin: {},
                listaFavOrigins: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default FavOrigins;
